export class EventEnum {
    static NotificationBell: "NotificationBell" = "NotificationBell";
    static CookiePolicy: "CookiePolicy" = "CookiePolicy";
    static LegalNotice: "LegalNotice" = "LegalNotice";
    static TermsAndConditions: "TermsAndConditions" = "TermsAndConditions";
    static ContactUs: "ContactUs" = "ContactUs";
    static DataManagement: "DataManagement" = "DataManagement";
    static FacebookLogin: "FacebookLogin" = "FacebookLogin";
    static GoogleLogin: "GoogleLogin" = "GoogleLogin";
    static RecommendStore: "RecommendStore" = "RecommendStore";
    static RateStore: "RateStore" = "RateStore";
    static Notifications: "Notifications" = "Notifications";
    static Favorites: "Favorites" = "Favorites";
    static CategoryMyProfile: "CategoryMyProfile" = "CategoryMyProfile";
    static CategoryMyTiendeo: "CategoryMyTiendeo" = "CategoryMyTiendeo";
    static CategoryHelp: "CategoryHelp" = "CategoryHelp";
    static CategoryNotifications: "CategoryNotifications" = "CategoryNotifications";
    static SaveProfileMobile: "SaveProfileMobile" = "SaveProfileMobile";
    static SavedPages: "SavedPages" = "SavedPages";
    static EditBirthdate: "EditBirthdate" = "EditBirthdate";
    static EditGender: "EditGender" = "EditGender";
    static EditName: "EditName" = "EditName";
    static EditZipCode: "EditZipCode" = "EditZipCode";
    static EditFamily: "EditFamily" = "EditFamily";
    static EditPets: "EditPets" = "EditPets";
    static EditProfileMobile: "EditProfileMobile" = "EditProfileMobile";
    static ReimbursementButton: "ReimbursementButton" = "ReimbursementButton";
    static LogOut: "LogOut" = "LogOut";
    static Recortes: "Recortes" = "Recortes";
    static LoyaltyCards: "LoyaltyCards" = "LoyaltyCards";
    static MyMedals: "MyMedals" = "MyMedals";
    static Cookies: "Cookies" = "Cookies";
    static WebNotifications: "WebNotifications" = "WebNotifications";
    static ExtractData: "ExtractData" = "ExtractData";
    static DeleteData: "DeleteData" = "DeleteData";
    static DeleteAccount: "DeleteAccount" = "DeleteAccount";
    static ShopfullyContact: "ShopfullyContact" = "ShopfullyContact";
}

export type Events = keyof Omit<typeof EventEnum, "prototype">;
